import { For } from "solid-js";
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

type Props = {
  icon: IconDefinition;
  class?: string;
};

export function FontAwesomeIcon(props: Props) {
  const paths = () => {
    const data = props.icon.icon[4];
    return Array.isArray(data) ? data : [data];
  };

  return (
    <svg
      class={props.class}
      viewBox={`0 0 ${props.icon.icon[0]} ${props.icon.icon[1]}`}
      aria-hidden="true"
    >
      <For each={paths()}>{(path, index) => <path d={path} opacity={paths().length > 1 && index() === 0 ? "0.4" : undefined} />}</For>
    </svg>
  );
}
